<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <div :key="item.path" v-if="!item.hidden && item.children">
        <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children && !item.alwaysShow"
          :to="item.path + '/' + item.children[0].path">
          <el-menu-item :index="item.path + '/' + item.children[0].path" class="menu-item"
            :class="{ 'submenu-title-noDropdown': !isNest }">
            <template v-if="item.children[0].meta">
              <m-icon v-if="item.children[0].meta.class" class="mr-3" :size="item.children[0].meta.size"
                :class="item.children[0].meta.class">{{ item.children[0].meta.icon }}</m-icon>
              <svg-icon class="mr-3" v-else :icon-class="item.children[0].meta.icon"
                :special-boi="item.children[0].meta.special"></svg-icon>
            </template>
            <span style="font-size: 16px;" v-if="item.children[0].meta && item.children[0].meta.sideBarTitle"
              slot="title">
              {{ item.children[0].meta.sideBarTitle }}
              <el-badge v-if="item.children[0].meta.sideBarTitle === 'Requests' && consentRequestCount !== 0"
                :value="consentRequestCount" class="item" />
            </span>
          </el-menu-item>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    this.$store.dispatch('UpdateRequestsCount')
  },

  computed: {
    consentRequestCount() {
      return this.$store.getters.requests_count
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    async fetchData() {
      await getRequestCount.getRequestCount()
    }

  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.menu-wrapper {
  .menu-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  }
}

.badge-item {
  margin-left: 5px;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue